export default "__VITE_ASSET__DclZt3w1__"